import reportData from "./reports.json";

const slugify = (str) =>
  decodeURIComponent(str)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/&/g, "and")
    .replace(/[^\w\s-]/g, "")   // remove all non-word chars
    .replace(/\s+/g, "-")       // replace spaces with dashes
    .replace(/--+/g, "-")       // collapse multiple dashes
    .trim();


// Group reports by dashboard
const dashboardMap = {};

for (const entry of reportData) {
  const dashKey = entry.dashboard;
  const reportSlug = slugify(entry.report);

  if (!dashboardMap[dashKey]) {
    dashboardMap[dashKey] = {
      label: dashKey,
      reports: [],
    };
  }

  const reportObj = dashboardMap[dashKey].reports.find(
    (r) => r.name === entry.report
  );

  if (reportObj) {
    reportObj.pages.push(
      ...entry.pages.map((p) => ({
        name: p.name,
        route: `/${slugify(dashKey)}/${reportSlug}/${slugify(p.name)}`,
      }))
    );
  } else {
    dashboardMap[dashKey].reports.push({
      name: entry.report,
      pages: entry.pages.map((p) => ({
        name: p.name,
        route: `/${slugify(dashKey)}/${reportSlug}/${slugify(p.name)}`,
      })),
    });
  }
}

const navConfig = Object.values(dashboardMap);

export default navConfig;
